export const MIN_BUILDING_CONSTRUCTION_YEAR = 1950;
export const MAX_PROJECTS_LIMIT = 2000;
export const DEFAULT_EXHAUST_GAS_LOSSES = 0;
